function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import BioExamPrescribedJournalEvent from "core/models/bio-exam-prescribed-journal-event";
import GenericPrescriptionUploadedJournalEvent from "core/models/generic-prescription-uploaded-journal-event";
import MedicalImagingPrescribedJournalEvent from "core/models/medical-imaging-prescribed-journal-event";
import MedicationPrescribedJournalEvent from "core/models/medication-prescribed-journal-event";
import ParamedicalCarePrescribedJournalEvent from "core/models/paramedical-care-prescribed-journal-event";
import PrescriptionJournalEvent from "core/models/prescription-journal-event";
import TlsPrescribedJournalEvent from "core/models/tls-prescribed-journal-event";
import dayjs from "dayjs";
import { getPrescriptionJournalEventComponent } from "./prescription-helpers";

/**
 * This class abstract the "xxxx-prescribed-journal-event"
 * It's a kind of decorator which allows the template to manipulate
 * only one kind of object.
 */
export default class Prescription {
  constructor(journalEvent) {
    _defineProperty(this, "journalEvent", void 0);
    _defineProperty(this, "occurredAt", void 0);
    _defineProperty(this, "pdfUrl", void 0);
    _defineProperty(this, "prescriptionComponent", void 0);
    this.journalEvent = journalEvent;
    this.occurredAt = journalEvent.occurredAt;
    this.pdfUrl = `${journalEvent.pdfUrl}`;
    this.prescriptionComponent = getPrescriptionJournalEventComponent(this.journalEvent);
    this.initWithJournalEvent(journalEvent);
  }
  initWithJournalEvent(journalEvent) {
    if (journalEvent instanceof BioExamPrescribedJournalEvent) {
      this.editionFormId = "prescription/bio-exam-edition-form";
      this.name = `Examens biologiques`;
      this.description = this.name + " du " + dayjs(this.occurredAt).format("DD/MM/YYYY");
      this.isImported = journalEvent.fileAttachments.length !== 0;
    } else if (journalEvent instanceof MedicationPrescribedJournalEvent) {
      this.editionFormId = "prescription/medication-edition-form";
      this.name = "Ordonnance médicamenteuse";
      this.description = this.name + " du " + dayjs(this.occurredAt).format("DD/MM/YYYY");
      this.isImported = journalEvent.fileAttachments.length !== 0;
    } else if (journalEvent instanceof TlsPrescribedJournalEvent) {
      this.editionFormId = "tls-prescription-edition-form";
      this.name = "Ordonnance de télésurvéillance";
      this.description = this.name + " valide jusqu'au " + dayjs(journalEvent.endDate).format("DD/MM/YYYY");
    } else if (journalEvent instanceof MedicalImagingPrescribedJournalEvent) {
      this.editionFormId = "prescription/medical-imaging-edition-form";
      this.name = "Ordonnance d'imagerie ou d'examen médical";
      this.description = this.name + (journalEvent.fileAttachments.length !== 0 ? " du " + dayjs(journalEvent.occurredAt).format("DD/MM/YYYY") : " valide jusqu'au " + dayjs(journalEvent.endDate).format("DD/MM/YYYY"));
      this.isImported = journalEvent.fileAttachments.length !== 0;
    } else if (journalEvent instanceof ParamedicalCarePrescribedJournalEvent) {
      this.editionFormId = "prescription/paramedical-care-edition-form";
      this.name = "Ordonnance de soins paramédicaux";
      this.description = this.name + (journalEvent.fileAttachments.length !== 0 ? " du " + dayjs(journalEvent.occurredAt).format("DD/MM/YYYY") : " valide jusqu'au " + dayjs(journalEvent.endDate).format("DD/MM/YYYY"));
      this.isImported = journalEvent.fileAttachments.length !== 0;
    } else if (journalEvent instanceof GenericPrescriptionUploadedJournalEvent) {
      this.editionFormId = "";
      this.name = "Ordonnance";
      this.description = this.name + " reçue le " + dayjs(journalEvent.occurredAt).format("DD/MM/YYYY");
    } else {
      throw new TypeError(`The journal event passed as parameter is not a prescription : ${journalEvent}`);
    }
  }
  get startDate() {
    return this.journalEvent.startDate;
  }
  get endDate() {
    return this.journalEvent.endDate;
  }
}